/* eslint-disable @ngrx/prefix-selectors-with-select */
import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromPatientSurgicalHistories from '../reducer/patient-surgical-history.reducer';

export const patientSurgicalHistoriesFeatureSelector =
  createFeatureSelector<fromPatientSurgicalHistories.PatientSurgicalHistoriesState>(
    fromPatientSurgicalHistories.patientSurgicalHistoriesFeatureKey
  );

const { selectEntities, selectAll } = fromPatientSurgicalHistories.patientSurgicalHistoriesAdapter.getSelectors();

export const selectPatientSurgicalHistoryEntities = createSelector(
  patientSurgicalHistoriesFeatureSelector,
  selectEntities
);

export const selectPatientSurgicalHistories = createSelector(patientSurgicalHistoriesFeatureSelector, selectAll);

export const selectCurrentCount = createSelector(
  selectPatientSurgicalHistories,
  patientSurgicalHistories => patientSurgicalHistories?.length ?? 0
);

export const selectError = createSelector(
  patientSurgicalHistoriesFeatureSelector,
  state => state?.baseState?.error ?? null
);

export const selectIsLoading = createSelector(
  patientSurgicalHistoriesFeatureSelector,
  state => state?.baseState?.isLoading ?? false
);

export const selectPageNumber = createSelector(
  patientSurgicalHistoriesFeatureSelector,
  state => state?.baseState?.pageNumber ?? 0
);

export const selectPageSize = createSelector(patientSurgicalHistoriesFeatureSelector, state => state?.pageSize ?? 5);

export const selectIsAtEndOfData = createSelector(
  patientSurgicalHistoriesFeatureSelector,
  state => state?.baseState?.isAtEndOfData ?? false
);

export const selectTotalRecordCount = createSelector(
  patientSurgicalHistoriesFeatureSelector,
  state => state?.baseState?.totalRecordCount ?? 0
);

export const selectIsFullDatasetLoaded = createSelector(
  patientSurgicalHistoriesFeatureSelector,
  state => state?.isFullDatasetLoaded ?? false
);

export const selectCachePatientId = createSelector(
  patientSurgicalHistoriesFeatureSelector,
  state => state?.cachePatientId ?? null
);

export const selectCacheLoadedAt = createSelector(
  patientSurgicalHistoriesFeatureSelector,
  state => state?.cacheLoadedAt ?? null
);

export const selectIsFullDatasetLoading = createSelector(
  patientSurgicalHistoriesFeatureSelector,
  state => state?.isFullDatasetLoading ?? false
);

export const selectFullDatasetError = createSelector(
  patientSurgicalHistoriesFeatureSelector,
  state => state?.fullDatasetError ?? null
);
